import { getRealmFromUrl } from "./KeycloakHelpers";

const getRedirectUri = () => {
  return window.origin.replace(`${getRealmFromUrl()}.`, "");
};
export default getRedirectUri;
